import { titulosApi } from "../view/titulos.service";
import { buildFiltersUrl, reshape_response } from "../../../../helpers/functions";

export const getTitulos = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    getTitulos: builder.query({
      query: ({ filter_params }) => ({
        url: buildFiltersUrl("/v1/api/titulo/", filter_params),
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Titulos",
                id,
              })),
              { type: "Titulos", id: "LIST" },
            ]
          : [{ type: "Titulos", id: "LIST" }],
      transformResponse: (response, meta, args) => {
        if (Array.isArray(response)) {
          return response?.map((el) => reshape_response(el, args.shape));
        } else {
          const resultsTransformed = response?.results?.map((el) =>
            reshape_response(el, args.shape)
          );
          return {
            results: resultsTransformed,
            count: response.count,
            next: response.next,
            previous: response.previous,
          };
        }
      },
    }),
  }),
});

export const { useGetTitulosQuery } = getTitulos;
